import React, { Component } from 'react';
import SignInForm from '../../molecules/SignInForm';
import PasswordForgetLink from '../../../../molecules/PasswordForget/atoms/PasswordForgetLink';
import UtekirkeLogo from '../../../../../../static/utekirkelogokors.png';
import Button from '../../../../atoms/Button';
import { navigate } from 'gatsby';
import { PATH_REGISTER } from '../../../../../constants/routes';
import { BrowserAgent } from './atoms/BrowserAgent';

/**
 * Innloggingsside for web panel
 *
 */

class SignIn extends Component {
  render() {
    return (
      <div className="login">
        <div className="login__content">
          <div className="login__content__inner">
            <div className="login__content__header">
              <img
                className="login__content__header__logo"
                src={UtekirkeLogo}
                alt="Utekirke logo"
              />
            </div>
            <div className="login__content__login-form">
              <div className="login__content__form">
                <SignInForm />
              </div>
              <div className="login__content__password-forget">
                <PasswordForgetLink />
              </div>
              <div className="login__register__buttons">
                <Button
                  text={'Registrer med epost'}
                  onClick={() => {
                    typeof window !== 'undefined' &&
                      navigate(PATH_REGISTER);
                  }}
                />
              </div>
              <div
                className="browser_agent_safari"
                style={{
                  fontSize: '14px',
                  color: 'black',
                  paddingTop: '2em',
                }}
              >
                <BrowserAgent />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SignIn;
